import { Field, Area, ImagePicker } from "./fields";

export const TrayectoriaTab = ({ draft, setDraft }) => {
  const items = draft.timeline || [];
  const update = (i, patch) => {
    const timeline = items.map((m, j) => (j === i ? { ...m, ...patch } : m));
    setDraft({ ...draft, timeline });
  };
  return (
    <div className="space-y-6">
      {items.map((m, i) => (
        <div key={i} className="rounded-xl border border-neutral-200 p-4 space-y-4">
          <Field label="Etapa / período" testId={`hito-periodo-${i}`} value={m.period}
            onChange={(v) => update(i, { period: v })} />
          <Field label="Título" testId={`hito-titulo-${i}`} value={m.title}
            onChange={(v) => update(i, { title: v })} />
          <Area label="Descripción" testId={`hito-descripcion-${i}`} rows={2} value={m.description}
            onChange={(v) => update(i, { description: v })} />
          <ImagePicker label="Logo (opcional)" testId={`hito-logo-${i}`} allowRemove value={m.logo}
            onChange={(v) => update(i, { logo: v })} />
        </div>
      ))}
    </div>
  );
};
